import React, { useState } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import products from "../json/LifeOrganics2.json";
import ModelComponent from "./ModalComponent";
import noImageFound from "../data/noimagefound.jpg";

type Product = typeof products[number];

const ProductCategories = () => {
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const tag = category === "online" ? "ayurveda" : category === "pharma" ? "pharma" : null;
  const title = category === "online" ? "Online" : category === "pharma" ? "Pharma" : "All Products";
  const filteredProducts = products.filter((product) => !tag || product.Tags.includes(tag));

  const showProduct = (product: Product) => {
    const images = product.Images.map((name) => {
      try {
        return require(`../data/${name}.png`) as string;
      } catch {
        return noImageFound;
      }
    });
    setSelectedProduct({ ...product, Images: images });
  };

  return (
    <Container sx={{ py: 3 }}>
      <Button component={Link} to="/products">Back to product catalogues</Button>
      <Typography component="h1" variant="h4" sx={{ textAlign: "center", my: 2 }}>{title}</Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        {filteredProducts.map((product, index) => (
          <Box key={`${product.Id}-${index}`} sx={{ minWidth: 0, flexBasis: { xs: "100%", sm: "calc((100% - 16px) / 2)", md: "calc((100% - 32px) / 3)", lg: "calc((100% - 48px) / 4)" } }}>
            <Button
              fullWidth
              sx={{ height: "100%", minHeight: 48, p: 2, bgcolor: "success.light", color: "#172c1c", overflowWrap: "anywhere", "&:hover": { bgcolor: "success.main", color: "common.white" } }}
              onClick={() => showProduct(product)}
            >
              {product.Product}
            </Button>
          </Box>
        ))}
      </Box>
      {filteredProducts.length === 0 && <p>No products available in this category.</p>}
      {selectedProduct && (
        <ModelComponent
          open={true}
          handleClose={() => setSelectedProduct(null)}
          data={selectedProduct}
        />
      )}
    </Container>
  );
};

export default ProductCategories;
